import { render, staticRenderFns } from "./work_game_vips.vue?vue&type=template&id=4408524f"
import script from "./work_game_vips.vue?vue&type=script&lang=js"
export * from "./work_game_vips.vue?vue&type=script&lang=js"
import style0 from "./work_game_vips.vue?vue&type=style&index=0&id=4408524f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports